import { useSelector } from "react-redux";
import { hasAccess } from "../../helpers/hierarchy"
import { get } from "lodash";

const WithPermission = ({ permission, children }) => {
    const storage = useSelector((state) => get(state, 'storage', {}));

    if (Array.isArray(permission)) {
        const hasAnyPermission = permission.some((perm) => hasAccess(storage, perm));
        return (<>{hasAnyPermission === true && <>{children}</>}</>);
    } else if (permission) {
        const hasPermission = hasAccess(storage, permission);
        return (<>{hasPermission === true && <>{children}</>}</>);
    }
    return null;
};

export default WithPermission;
